import { render, staticRenderFns } from "./calcRepAdmin.vue?vue&type=template&id=52020c5c"
import script from "./calcRepAdmin.vue?vue&type=script&lang=js"
export * from "./calcRepAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports